import { render, staticRenderFns } from "./LeaveChat.vue?vue&type=template&id=7bf6c6fa"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bf6c6fa')) {
      api.createRecord('7bf6c6fa', component.options)
    } else {
      api.reload('7bf6c6fa', component.options)
    }
    module.hot.accept("./LeaveChat.vue?vue&type=template&id=7bf6c6fa", function () {
      api.rerender('7bf6c6fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/LeaveChat.vue"
export default component.exports